import React, { FC, isValidElement, ReactNode, useMemo } from 'react';
import { ProTabs, ProCol, ProRow } from '../antd';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { TabsProps } from 'antd/lib/tabs';
import { SuperFormItemProps } from '../SuperForm/interface';
import { ColProps } from 'antd/lib/col';
import { TabItemType } from '../antd/Tabs';

export interface ITabPaneProps extends Omit<TabItemType, 'children'> {
  /** 子节点配置 */
  children: ReactNode | SuperFormItemProps[];
  /** 是否展示 */
  hidden?: boolean;
}
export interface SearchFormTabsProps extends BaseSearchFormItemProps {
  /** tabsProps */
  tabsProps?: TabsProps;
  /** tabPanes */
  tabPanes?: ITabPaneProps[];
  /** 每行显示多少个表单 */
  defaultLineNumber?: number;
  /** 每个Item的默认labelCol配置 */
  defaultLabelCol?: ColProps;
}
/** 标签页 */
export const SearchFormTabs: FC<SearchFormTabsProps> = props => {
  const {
    style,
    span,
    offset,
    order,
    pull,
    push,
    tabsProps,
    tabPanes,
    isDetail,
    defaultLineNumber,
    defaultLabelCol,
    form,
    testId,
    labelCol,
  } = props;
  const renderChild: any = (children: ReactNode) => {
    if (Array.isArray(children)) {
      let spanNumber: number | undefined = defaultLineNumber
        ? Math.floor(24 / defaultLineNumber)
        : undefined;
      return React.Children.map(children, child => {
        const childElement = child as React.FunctionComponentElement<
          SuperFormItemProps
        >;
        const tabPanChilren = childElement?.props?.children;
        if (Array.isArray(tabPanChilren)) {
          return React.cloneElement(childElement, {
            form,
            testId,
            children: renderChild(tabPanChilren),
          });
        }
        const otherParams: any = {
          form,
          testId,
          defaultLineNumber,
          defaultLabelCol,
          span: childElement.props.span || spanNumber || span,
          labelCol: {
            ...labelCol,
            ...defaultLabelCol,
            ...childElement.props.labelCol,
          },
        };
        return React.cloneElement(childElement, otherParams);
      });
    }
    if (isValidElement(children)) {
      // @ts-ignore
      return React.cloneElement(children, { isDetail });
    }
    return children;
  };
  const tabItems: TabsProps['items'] = useMemo(() => {
    const newTabItems: TabsProps['items'] = [];
    tabPanes?.forEach(item => {
      const { key, tabKey, label, tab, children, hidden, ...restItem } = item;
      if (!hidden) {
        newTabItems.push({
          forceRender: true,
          key: tabKey || key,
          label: tab || label,
          children: (
            <div>
              {Array.isArray(children) ? (
                <ProCol span={24} style={{ padding: '12px 0' }}>
                  <ProRow gutter={24}>{renderChild(children)}</ProRow>
                </ProCol>
              ) : (
                renderChild(children)
              )}
            </div>
          ),
          ...restItem,
        });
      }
    });
    return newTabItems;
  }, [tabPanes]);
  return (
    <ProCol
      style={{ ...style, position: 'relative' }}
      span={24}
      offset={offset}
      order={order}
      pull={pull}
      push={push}
    >
      <ProTabs {...tabsProps} items={tabItems} />
    </ProCol>
  );
};

SearchFormTabs.displayName = SearchFormItemEnum.SearchFormTabs;

export default SearchFormTabs;
